import { Injectable } from '@angular/core';
import { AppSettings } from 'app/app.settings';
import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';

export type GtoOperationType = 'delete' | 'insert' | 'update';
export interface Gto {
	table: string;
	operation: GtoOperationType;
	keycol?: string;
	keytyp?: string;
	keyvals?: any[];
	// Either keytyp + keyvals Or where need to be provided for update / delete
	where?: string;
	properties?: GtoProperty[]; // delete operation doesn't need to pass properties
}
export interface GtoProperty {
	[col: string]: {
		type: string; // 'text' | 'date' | ...
		value: any;
		expression?: boolean
	}
}

@Injectable({
	providedIn: 'root'
})
export class GtoService {

	test = {
		geom: '0101000020110F000000000000009898400000000000C05D40',
		layer: 'default',
		mpt_guid: '{398F6F59-C422-4AE7-8A39-18F3F3FFCDE3}',
		mpt_reach: 1,
		mpt_redaction: 'R-ReDraw is also Redacted',
		mpt_resolved: true,
		mpt_session_id: '2d7bbc01-526c-49af-b20e-eac3cee3ac38',
		mpt_split_insert: 'I',
		mpt_state_cd: 'AZ'
	}
	constructor(
		private requestService: CommonRequestService,
		private userService: UserService
	) { }

	buildGto(table: string, operation: GtoOperationType, keyCol, properties: GtoProperty[],whereClause?: string, keyColType?: string, keyColValues?: any[]): Gto {
		const gto: Gto = {
			table: table,
			operation: operation,
			keycol: keyCol,
			properties: properties
		}
		if (whereClause) {
			gto.where = whereClause;
		}
		if (keyColType) {
			gto.keytyp = keyColType;
		}
		if (keyColValues) {
			gto.keyvals = keyColValues;
		}
		return gto;
	}

	processGto(gto: Gto[], globalIdCol?: string) {
		return new Promise<{sessionId; globalIds?: any[]}>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'common/processGto';
			const body: any = {
				gto: JSON.stringify({
					dbprocs: gto
				}),
				userId: this.userService.getUserInfo().userId,
				userSubscriptionId: this.userService.getUserInfo().userSubId,
				source: 'C' // cloud
			};
			if (globalIdCol) {
				body.columnReturn = globalIdCol;
			}
			this.requestService.requestPost(url, body, rsp => {
				console.log(rsp);
				let globalIds = [];
				if (globalIdCol && rsp.data && rsp.data.content) {
					const obj = JSON.parse(rsp.data.content);
					if (obj[globalIdCol]) {
						globalIds = obj[globalIdCol];
					}
				}
				resolve({
					sessionId: rsp.misc.session_id,
					globalIds: globalIds
				});
			}, err => reject(err), true);
		});
	}

}
